import * as z from 'zod/v4';

export const loginRequest = z.object({
	code: z.string().nonempty(),
	redirect_uri: z.string().nonempty()
});

export const refreshTokenRequest = z.object({
	refresh_token: z.string().nonempty()
});

export const registerRequest = z.object({
	name: z
		.string({ error: 'Wajib diisi' })
		.nonempty({ error: 'Wajib diisi' })
		.max(100, { error: 'Maks.100 karakter' }),
	email: z
		.email({ error: 'Format email tidak sesuai' })
		.nonempty({ error: 'Wajib diisi' })
		.max(100, { error: 'Maks.100 karakter' })
});

export type LoginRequest = z.output<typeof loginRequest>;
export type RefreshTokenRequest = z.output<typeof refreshTokenRequest>;
export type RegisterRequest = z.output<typeof registerRequest>;
